import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=72ed4112&scoped=true&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=72ed4112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed4112",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsArrowleftArrowLeft24px: require('/var/www/packages/theme/components/icons/arrowleft/ArrowLeft24px.vue').default})
